<template>
  <VFooter app padless fixed class="bg-background px-2 pb-4">
    <VRow class="bg-surface w-100 pa-4 mx-0 border-t" align="center" justify="space-between" style="border-radius: 4px">
      <VCol cols="auto" class="pa-0">{{ appConfig.name }} © {{ new Date().getFullYear() }}</VCol>

      <VCol cols="auto" class="pa-0">
        {{ $t('poweredBy') }}
        <a target="_blank" class="text-decoration-none text-error" rel="noopener noreferrer" href="https://devlance.co">Devlance</a>
      </VCol>
    </VRow>
  </VFooter>
</template>

<script setup>
import { appConfig } from '@appConfig';
</script>
